module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.e208d9aa.woff2";